import React from 'react';
import { ReactRenderHelper as ReactDOM } from '../../../Scripts/Util/ReactRenderHelper';
import { PharmacyCardSharerApp } from '../../Components/PharmacyCardSharer/PharmacyCardSharerApp'

window.PharmacyCardSharerApp = (options) => {
    ReactDOM.render(
        <PharmacyCardSharerApp
            {...options}
            onClose={() => { ReactDOM.unmountComponentAtNode(document.getElementById(options.wrapper)); options.onClose();}}
        />,
        document.getElementById(options.wrapper));
};
